exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.product-add[data-v-03f221dc]{padding-bottom:50px\n}\n.img[data-v-03f221dc]{margin-top:10px\n}", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/auth/role/add.vue"],"names":[],"mappings":";AACA,8BAA8B,mBAAmB;CAChD;AACD,sBAAsB,eAAe;CACpC","file":"add.vue","sourcesContent":["\n.product-add[data-v-03f221dc]{padding-bottom:50px\n}\n.img[data-v-03f221dc]{margin-top:10px\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03f221dc","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/styles/variables.scss","/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/styles/mixin.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/auth/role/add.vue
// module id = I3Gb
// module chunks = 0